import { Navigation } from '../translations-types';

const translations: Navigation = {
  dashboard: 'Dashboard',
  customers: 'Cliënten',
  employees: 'Medewerker',
  questionnaires: 'Vragenlijsten',
  settings: 'Instellingen',
  import: 'Importeren cliënten',
  subscriptions: 'Abonnementen',
  payments: 'Betalingen',
  messaging: 'Whatsapp krediet',
  salons: 'Vestiging(en)',
  roles: 'Rollen',
  customFields: 'Klantlabels',
  organisationSettings: 'Organisatie instellingen',
  advice: 'Advies',
  adviceConditions: 'Advies-module condities',
  adviceGroups: 'Advies-module groepen',
  trainings: 'Blauwdruk',
  userManual: 'Handleiding',
  courses: 'Academie',
  salesImport: 'Importeren verkoopregels',
  nameMatch: 'Klantnaam vergelijken',
  plans: 'Trajecten',
  treatmentAnalysis: 'Behandelanalyse',
  koppelingen: 'Koppelingen',
  groupGeneral: 'Algemeen',
  groupCompany: 'Bedrijf',
  groupCustomers: 'Klanten',
  groupPlans: 'Trajecten',
  groupData: 'Gegevens & import',
  spokenAdvice: 'Spoken AI advies',
  sneladvies: 'Speciaal voor jou',
  documentsAndConsentForms: 'Documenten & Instemmings-formulieren',
  assistants: 'AI krediet',
  assistantsConfig: 'Assistenten',
  calendar: 'Agenda',
  salonized: 'Salonized',
};

export default translations;
